class DefaultLayoutController {
	constructor() {}

	$onInit() {}

	$onChanges(changes) {
		// if (changes.series && changes.series.currentValue) {
		// 	this.seriesArray = Object.keys(changes.series.currentValue).map(prop => changes.series.currentValue[prop]);
		// }
	}
}

export default {
	template: require('./default.html'),
	controller: DefaultLayoutController,
	bindings: {
		series: '<'
	},
	controllerAs: 'vm'
};
